

(function(){

  const ICN = {
    users:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
    box:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96 12 12.01l8.73-5.05"/><path d="M12 22.08V12"/></svg>`,
    star:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`,
  };

  function renderUSP(root){
    const track = root.querySelector('.js-usp__track');
    if(!track) return;
    const items = [
      {icon:'users', text:root.dataset.customers},
      {icon:'box', text:root.dataset.shipping},
      {icon:'star', text:root.dataset.trustpilot},
    ];
    
    const html = [0,1,2].map(loopIdx =>
      items.map(it => `
        <div class="js-usp__item"${loopIdx>0?' data-clone="1" aria-hidden="true"':''}>
          <span class="js-usp__icon">${ICN[it.icon]||''}</span>
          <span class="js-usp__text">${it.text}</span>
        </div>
      `).join('')
    ).join('');
    track.innerHTML = html;
  }

  function init(){
    document.querySelectorAll('[data-usp]').forEach(renderUSP);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.JsUSP = { render: init };
})();

(function(){
  function initVariantSelector(box){
    if(box.dataset.croVariantsReady === 'true') return;

    const toggle = box.querySelector('[data-variants-toggle]');
    const list = box.querySelector('.js-pdp__variants-list');
    if(!toggle || !list) return;

    const setOpen = open => {
      toggle.setAttribute('aria-expanded', String(open));
      list.hidden = !open;
    };

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('click', event => {
      if(!box.contains(event.target)) setOpen(false);
    });

    box.addEventListener('keydown', event => {
      if(event.key === 'Escape'){
        setOpen(false);
        toggle.focus();
      }
    });

    box.dataset.croVariantsReady = 'true';
  }

  function initReadMore(button){
    if(button.dataset.croReadMoreReady === 'true') return;

    const teaser = button.previousElementSibling;
    if(!teaser?.classList.contains('js-pdp__teaser')) return;

    button.addEventListener('click', () => {
      const isOpen = teaser.classList.toggle('is-open');
      button.textContent = isOpen ? button.dataset.lessLabel : button.dataset.moreLabel;
    });

    button.dataset.croReadMoreReady = 'true';
  }

  function initProductControls(root = document){
    root.querySelectorAll('[data-variants]').forEach(initVariantSelector);
    root.querySelectorAll('[data-readmore]').forEach(initReadMore);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', () => initProductControls());
  } else {
    initProductControls();
  }

  document.addEventListener('shopify:section:load', event => initProductControls(event.target));
})();

(function(){
  function initCar(car){
    if(car.dataset.croCarouselReady === 'true') return;
    const track = car.querySelector('[data-track]');
    const dotsWrap = car.querySelector('[data-dots]');
    const prev = car.querySelector('.js-car__nav--prev');
    const next = car.querySelector('.js-car__nav--next');
    if(!track) return;

    const slides = [...track.children];
    if(!slides.length) return;

    function slideWidth(){
      const s = slides[0];
      if(!s) return 0;
      const r = s.getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      return r.width + gap;
    }

    function visibleCount(){
      return Math.max(1, Math.round(track.clientWidth / slideWidth()));
    }

    function pageCount(){
      return Math.max(1, Math.ceil(slides.length / visibleCount()));
    }

    function currentPage(){
      const w = slideWidth();
      return Math.round(track.scrollLeft / (w * visibleCount()));
    }

    function renderDots(){
      if(!dotsWrap) return;
      const pages = pageCount();
      const cur = currentPage();
      dotsWrap.innerHTML = '';
      for(let i=0; i<pages; i++){
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'js-car__dot' + (i===cur?' is-active':'');
        b.setAttribute('aria-label', `Gå til side ${i+1}`);
        b.addEventListener('click', ()=>{
          track.scrollTo({left: i * slideWidth() * visibleCount(), behavior:'smooth'});
        });
        dotsWrap.appendChild(b);
      }
    }

    function updateNav(){
      const max = track.scrollWidth - track.clientWidth;
      if(prev) prev.classList.toggle('is-hidden', track.scrollLeft <= 2);
      if(next) next.classList.toggle('is-hidden', track.scrollLeft >= max - 2);
    }

    function updateDotsActive(){
      if(!dotsWrap) return;
      const cur = currentPage();
      [...dotsWrap.children].forEach((d,i)=>d.classList.toggle('is-active', i===cur));
    }

    if(prev) prev.addEventListener('click', ()=>{
      track.scrollBy({left: -slideWidth() * visibleCount(), behavior:'smooth'});
    });
    if(next) next.addEventListener('click', ()=>{
      track.scrollBy({left: slideWidth() * visibleCount(), behavior:'smooth'});
    });

    let scrollFrame = 0;
    track.addEventListener('scroll', ()=>{
      if(scrollFrame) return;
      scrollFrame = requestAnimationFrame(()=>{
        scrollFrame = 0;
        updateNav();
        updateDotsActive();
      });
    }, {passive:true});

    let resizeTO;
    window.addEventListener('resize', ()=>{
      clearTimeout(resizeTO);
      resizeTO = setTimeout(()=>{ renderDots(); updateNav(); }, 120);
    });

    renderDots();
    updateNav();
    car.dataset.croCarouselReady = 'true';
  }

  function init(){
    document.querySelectorAll('.js-car').forEach(initCar);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.JsCar = { init };
})();

(function(){
  let scheduled = false;

  function initRecommendationScroll(rail, clone){
    const recommendations = clone.querySelector('.cro-cart-recommendations');
    const scroll = recommendations?.querySelector(':scope > ul');
    if(!recommendations || !scroll) return;

    let frame = 0;
    const update = ()=>{
      frame = 0;
      const maxScroll = Math.max(0, scroll.scrollHeight - scroll.clientHeight);
      const cloneRect = clone.getBoundingClientRect();
      const scrollRect = scroll.getBoundingClientRect();

      clone.style.setProperty('--cro-cart-recommendations-top', `${Math.max(0, scrollRect.top - cloneRect.top)}px`);
      clone.classList.toggle('is-recommendations-overflowing', maxScroll > 4);
      clone.classList.toggle('is-recommendations-scrolled', scroll.scrollTop > 4);
      clone.classList.toggle('is-recommendations-bottom', maxScroll <= 4 || scroll.scrollTop >= maxScroll - 4);
    };
    const scheduleUpdate = ()=>{
      if(frame) return;
      frame = requestAnimationFrame(update);
    };

    scroll.addEventListener('scroll', scheduleUpdate, {passive:true});

    const resizeObserver = new ResizeObserver(scheduleUpdate);
    resizeObserver.observe(clone);
    resizeObserver.observe(recommendations);
    resizeObserver.observe(scroll);

    const mutationObserver = new MutationObserver(scheduleUpdate);
    mutationObserver.observe(recommendations, {childList:true, subtree:true});

    update();
    rail._croRecommendationScrollCleanup = ()=>{
      if(frame) cancelAnimationFrame(frame);
      scroll.removeEventListener('scroll', scheduleUpdate);
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }

  function mirrorCrossSell(drawer){
    const source = drawer.querySelector('form.contents .cm-cart-cross-sell');
    const recommendations = drawer.querySelector('form.contents .cro-cart-recommendations');
    const hasOffer = source?.querySelector('.js-cart__featured') || recommendations?.querySelector('li');
    const desktop = window.matchMedia('(min-width: 769px)').matches;
    let rail = drawer.querySelector('.cro-cart-rail');
    if(!desktop || !source || !hasOffer){
      drawer.classList.remove('cro-cart-enhanced');
      rail?._croRecommendationScrollCleanup?.();
      rail?.remove();
      return;
    }

    const signature = `${source.innerHTML}${recommendations?.innerHTML || ''}`;
    if(rail?.dataset.signature === signature) return;

    if(!rail){
      rail = document.createElement('aside');
      rail.className = 'cro-cart-rail';
      rail.setAttribute('aria-label', 'Produktanbefalinger');
      drawer.prepend(rail);
    }

    rail.dataset.signature = signature;
    rail._croRecommendationScrollCleanup?.();
    rail.replaceChildren();
    const clone = source.cloneNode(true);
    clone.removeAttribute('data-cm-cart-cross-sell');
    if(recommendations){
      clone.classList.remove('cm-cart-cross-sell--metrics-only');
      clone.appendChild(recommendations.cloneNode(true));
    }
    rail.appendChild(clone);
    initRecommendationScroll(rail, clone);

    drawer.classList.add('cro-cart-enhanced');
  }

  function scan(){
    scheduled = false;
    document.querySelectorAll('[data-load-target="cart-drawer"] .drawer--right').forEach(mirrorCrossSell);
  }

  function schedule(){
    if(scheduled) return;
    scheduled = true;
    queueMicrotask(scan);
  }

  const cartRoot = document.querySelector('[data-load-target="cart-drawer"]');
  if(cartRoot){
    const observer = new MutationObserver(schedule);
    observer.observe(cartRoot, {childList:true, subtree:true});
  }
  document.addEventListener('cart:fetched', schedule);
  window.matchMedia('(min-width: 769px)').addEventListener('change', schedule);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();

(function(){
  const cartRoot = document.querySelector('[data-load-target="cart-drawer"]');
  if(!cartRoot) return;

  let scheduled = false;
  let removingInFlight = false;
  let pendingRemovedKey = '';
  let pendingRemovedVariantId = '';
  let pendingRemoveButton = null;

  function syncRemoveControls(){
    cartRoot.querySelectorAll('.cro-cart-item__remove').forEach(button => {
      const matchesPendingItem = button === pendingRemoveButton;

      button.disabled = removingInFlight;
      button.classList.toggle('is-loading', removingInFlight && matchesPendingItem);
      if(removingInFlight && matchesPendingItem) button.setAttribute('aria-busy','true');
      else button.removeAttribute('aria-busy');
    });
  }

  function finishRemove(){
    pendingRemovedKey = '';
    pendingRemovedVariantId = '';
    pendingRemoveButton = null;
    removingInFlight = false;
    syncRemoveControls();
  }

  function readCart(source){
    try{
      return JSON.parse(source.querySelector('[data-cm-cart-data]')?.textContent || '{}');
    }catch(error){
      return {};
    }
  }

  function normalise(value){
    return String(value || '').trim().toLocaleLowerCase().replace(/\s+/g,' ');
  }

  function enhanceShipping(drawer,source){
    const form = drawer.querySelector('form.contents');
    const progress = form?.querySelector(':scope > .progress');
    const copy = progress?.previousElementSibling;
    if(!copy || copy.tagName !== 'P') return;

    const remaining = Number(source.dataset.cmCartShippingRemaining || 0);
    const remainingMoney = source.dataset.cmCartShippingRemainingMoney || '';
    const signature = `${remaining}:${remainingMoney}`;
    if(copy.dataset.croSignature === signature) return;

    copy.dataset.croSignature = signature;
    copy.classList.add('cro-cart-shipping-copy');
    progress.classList.add('cro-cart-shipping-progress');

    if(remaining > 0){
      const amount = document.createElement('strong');
      amount.textContent = remainingMoney;
      copy.replaceChildren(
        document.createTextNode(`${cartRoot.dataset.croCartShippingPrefix} `),
        amount,
        document.createTextNode(` ${cartRoot.dataset.croCartShippingSuffix}`)
      );
    }else{
      copy.textContent = cartRoot.dataset.croCartShippingSuccess;
    }
    progress.classList.toggle('is-free-shipping', remaining <= 0);
  }

  function enhanceItems(drawer,source){
    const cart = readCart(source);
    const itemsContainer = source.parentElement;
    if(!itemsContainer || !Array.isArray(cart.items)) return;

    const itemNodes = Array.from(itemsContainer.children).filter((node) => {
      return node !== source && node.querySelector('.quantity') && node.firstElementChild?.querySelector('a');
    });

    itemNodes.forEach((itemNode,index) => {
      const item = cart.items[index];
      if(!item) return;

      const image = itemNode.firstElementChild;
      const content = image?.nextElementSibling;
      const heading = content?.firstElementChild;
      const quantity = content?.querySelector('.quantity');
      const bottom = quantity?.parentElement;
      const price = bottom?.querySelector('p');
      if(!image || !content || !heading || !quantity || !bottom || !price) return;

      itemNode.classList.add('cro-cart-item');
      image.classList.add('cro-cart-item__image');
      content.classList.add('cro-cart-item__content');
      heading.classList.add('cro-cart-item__heading');
      bottom.classList.add('cro-cart-item__bottom');
      quantity.classList.add('cro-cart-item__quantity');
      price.classList.add('cro-cart-item__price');

      const title = heading.querySelector('p:first-child');
      const variant = heading.querySelector('p:nth-child(2)');
      title?.classList.add('cro-cart-item__title');
      variant?.classList.add('cro-cart-item__variant');
      if(variant){
        const variantText = normalise(variant.textContent);
        const titleText = normalise(title?.textContent);
        variant.hidden = !variantText || variantText === titleText || variantText === 'default title';
      }

      const quantityButtons = quantity.querySelectorAll('button');
      if(quantityButtons[0] && quantityButtons[0].textContent.trim() !== '−'){
        quantityButtons[0].textContent = '−';
      }

      let right = itemNode.querySelector(':scope > .cro-cart-item__right');
      if(!right){
        right = document.createElement('div');
        right.className = 'cro-cart-item__right';
        itemNode.appendChild(right);
      }
      if(price.parentElement !== right) right.prepend(price);

      let remove = right.querySelector('.cro-cart-item__remove');
      if(!remove){
        remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cro-cart-item__remove';
        remove.textContent = cartRoot.dataset.croCartRemoveLabel;
        right.appendChild(remove);
      }
      remove.dataset.lineKey = item.key;
      const productLink = itemNode.querySelector('a[href*="/products/"]');
      if(productLink){
        try{
          const variantId = new URL(productLink.href,window.location.origin).searchParams.get('variant');
          if(variantId) remove.dataset.variantId = variantId;
        }catch(error){
          delete remove.dataset.variantId;
        }
      }
      syncRemoveControls();
    });
  }

  function filterRecommendations(drawer,source){
    const cart = readCart(source);
    const itemsContainer = source.parentElement;
    if(!itemsContainer || !Array.isArray(cart.items)) return;

    const recommendations = drawer.querySelector('.cro-cart-recommendations') ||
      Array.from(itemsContainer.children).find((node) => {
        return node !== source && node.querySelector(':scope > p.heading + ul');
      });
    const list = recommendations?.querySelector(':scope > p.heading + ul');
    if(!recommendations || !list) return;

    const handlesInCart = new Set(cart.items.map(item => String(item.handle || '')).filter(Boolean));
    const productIdsInCart = new Set(cart.items.map(item => String(item.product_id || '')).filter(Boolean));
    const variantIdsInCart = new Set(cart.items.map(item => String(item.variant_id || item.id || '')).filter(Boolean));
    let visibleCards = 0;

    Array.from(list.children).forEach((card) => {
      const productLink = card.querySelector('a[href*="/products/"]');
      const productId = card.querySelector('.jdgm-widget[data-id]')?.dataset.id || '';
      const variantId = card.querySelector('form[data-cm-upsell-atc] input[name="id"]')?.value || '';
      let handle = '';

      if(productLink){
        try{
          handle = new URL(productLink.href,window.location.origin).pathname
            .split('/products/')[1]?.split('/')[0] || '';
          handle = decodeURIComponent(handle);
        }catch(error){
          handle = '';
        }
      }

      const isInCart = (handle && handlesInCart.has(handle)) ||
        (productId && productIdsInCart.has(String(productId))) ||
        (variantId && variantIdsInCart.has(String(variantId)));
      if(card.hidden !== Boolean(isInCart)) card.hidden = Boolean(isInCart);
      if(!isInCart) visibleCards += 1;
    });

    const hideRecommendations = visibleCards === 0;
    if(recommendations.hidden !== hideRecommendations) recommendations.hidden = hideRecommendations;
  }

  function createSummaryRow(className,label,value){
    const row = document.createElement('div');
    row.className = `cro-cart-summary__row ${className}`;
    const name = document.createElement('span');
    const amount = document.createElement('b');
    name.textContent = label;
    amount.textContent = value;
    row.append(name,amount);
    return row;
  }

  function createTicker(){
    const ticker = document.createElement('div');
    ticker.className = 'cro-cart-miniusp';
    ticker.setAttribute('aria-hidden','true');

    const inner = document.createElement('div');
    inner.className = 'cro-cart-miniusp__inner';
    const track = document.createElement('div');
    track.className = 'cro-cart-miniusp__track';

    const entries = [
      {
        text: cartRoot.dataset.croCartCustomers,
        icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>'
      },
      {
        text: cartRoot.dataset.croCartFreeShipping,
        icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96 12 12.01l8.73-5.05"/><path d="M12 22.08V12"/></svg>'
      },
      {
        text: cartRoot.dataset.croCartTrustpilot,
        icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'
      }
    ];

    entries.forEach((entry) => {
      const item = document.createElement('div');
      item.className = 'cro-cart-miniusp__item';
      item.innerHTML = entry.icon;
      const text = document.createElement('span');
      text.textContent = entry.text;
      item.appendChild(text);
      track.appendChild(item);
    });

    inner.appendChild(track);
    ticker.appendChild(inner);
    return ticker;
  }

  function enhanceSummary(drawer,source){
    const footer = drawer.querySelector('form.contents > .drawer__content.border-t');
    const checkout = footer?.querySelector('.cart-drawer-checkout-btn');
    const nativeTotals = footer?.firstElementChild;
    if(!footer || !checkout || !nativeTotals) return;

    nativeTotals.classList.add('cro-cart-native-totals');
    const savings = Number(source.dataset.cmCartSavings || 0);
    const savingsMoney = source.dataset.cmCartSavingsMoney || '';
    const totalMoney = source.dataset.cmCartDisplayTotalMoney || source.dataset.cmCartTotalMoney || '';
    const shippingPrice = Number(source.dataset.cmCartShippingPrice || 0);
    const shippingMoney = source.dataset.cmCartShippingPriceMoney || '';
    const signature = `${savings}:${savingsMoney}:${shippingPrice}:${shippingMoney}:${totalMoney}`;

    let summary = footer.querySelector('.cro-cart-summary');
    if(!summary){
      summary = document.createElement('div');
      summary.className = 'cro-cart-summary';
      nativeTotals.insertAdjacentElement('afterend',summary);
    }

    if(summary.dataset.signature !== signature){
      summary.dataset.signature = signature;
      summary.replaceChildren();
      if(savings > 0){
        summary.appendChild(createSummaryRow(
          'cro-cart-summary__row--savings',
          cartRoot.dataset.croCartSavingsLabel,
          `−${savingsMoney}`
        ));
      }
      summary.appendChild(createSummaryRow(
        'cro-cart-summary__row--shipping',
        cartRoot.dataset.croCartShippingLabel,
        shippingPrice > 0 ? shippingMoney : cartRoot.dataset.croCartFreeLabel
      ));
      summary.appendChild(createSummaryRow(
        'cro-cart-summary__row--total',
        cartRoot.dataset.croCartTotalLabel,
        totalMoney
      ));
    }

    const terms = footer.querySelector('label');
    terms?.classList.add('cro-cart-terms');
    const paymentMethods = Array.from(footer.children).find((node) => {
      return node !== nativeTotals && node !== summary && node !== terms && node !== checkout && node.querySelector('ul svg, ul img');
    });
    paymentMethods?.classList.add('cro-cart-payment-methods');

    if(!footer.querySelector('.cro-cart-miniusp')){
      checkout.insertAdjacentElement('afterend',createTicker());
    }
  }

  function enhanceDrawer(drawer){
    const source = drawer.querySelector('form.contents .cm-cart-cross-sell[data-cm-cart-cross-sell]');
    if(!source) return;
    enhanceShipping(drawer,source);
    enhanceItems(drawer,source);
    filterRecommendations(drawer,source);
    enhanceSummary(drawer,source);
  }

  function scan(){
    scheduled = false;
    cartRoot.querySelectorAll('.drawer--right').forEach(enhanceDrawer);
    syncRemoveControls();
  }

  function schedule(){
    if(scheduled) return;
    scheduled = true;
    queueMicrotask(scan);
  }

  cartRoot.addEventListener('click',async(event) => {
    const button = event.target.closest('.cro-cart-item__remove');
    if(!button || button.disabled || removingInFlight) return;

    event.preventDefault();
    removingInFlight = true;
    pendingRemovedKey = button.dataset.lineKey || '';
    pendingRemovedVariantId = button.dataset.variantId || '';
    pendingRemoveButton = button;
    syncRemoveControls();
    try{
      const cartResponse = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
      if(!cartResponse.ok) throw new Error(`Cart fetch failed: ${cartResponse.status}`);
      const currentCart = await cartResponse.json();
      const variantId = button.dataset.variantId || '';
      const currentItem = variantId && Array.isArray(currentCart.items)
        ? currentCart.items.find(item => String(item.variant_id || item.id) === variantId)
        : null;
      const lineKey = currentItem?.key || button.dataset.lineKey || '';
      if(!lineKey) throw new Error('Cart line key missing');
      pendingRemovedKey = lineKey;
      pendingRemovedVariantId = String(currentItem?.variant_id || currentItem?.id || pendingRemovedVariantId);
      syncRemoveControls();

      const response = await fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:lineKey,quantity:0})
      });
      if(!response.ok) throw new Error(`Cart remove failed: ${response.status}`);
      const cart = await response.json();
      if(window.theme) window.theme.cart = cart;
      document.dispatchEvent(new CustomEvent('cart:fetched',{detail:cart}));
      queueMicrotask(finishRemove);
    }catch(error){
      console.warn('[cro-cart-remove]', error);
      finishRemove();
      button.setAttribute('title', cartRoot.dataset.croCartRemoveError || 'Kunne ikke fjerne varen');
    }
  });

  new MutationObserver(schedule).observe(cartRoot,{childList:true,subtree:true});
  document.addEventListener('cart:fetched',schedule);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',schedule);
  else schedule();
})();

(function(){
  function initStickyAtc(bar){
    if(bar.dataset.stickyAtcReady === 'true') return;

    const section = bar.closest('.shopify-section');
    const mainButton = section?.querySelector('.js-pdp__atc') || document.querySelector('.js-pdp__atc');
    const stickyButton = bar.querySelector('[data-sticky-atc-button]');
    const footer = document.querySelector('footer');
    const cartRoot = document.querySelector('[data-load-target="cart-drawer"]');
    if(!mainButton || !stickyButton) return;

    let frame = 0;

    const update = () => {
      frame = 0;
      const mainRect = mainButton.getBoundingClientRect();
      const footerRect = footer?.getBoundingClientRect();
      const hasPassedMainButton = mainRect.bottom < 0;
      const footerIsClear = !footerRect || footerRect.top > window.innerHeight;
      const openDrawer = cartRoot?.querySelector('.drawer--right:not([hidden])');
      const shouldShow = hasPassedMainButton && footerIsClear && !openDrawer;

      bar.classList.toggle('is-show', shouldShow);
      bar.setAttribute('aria-hidden', String(!shouldShow));
      stickyButton.disabled = mainButton.disabled;
    };

    const schedule = () => {
      if(frame) return;
      frame = requestAnimationFrame(update);
    };

    stickyButton.addEventListener('click', () => {
      if(mainButton.disabled) return;

      stickyButton.classList.add('is-loading');
      stickyButton.setAttribute('aria-busy', 'true');
      stickyButton.disabled = true;

      let loadingCleared = false;
      let loadingTimer;
      const mainButtonObserver = new MutationObserver(() => {
        if(!mainButton.disabled) clearLoading();
      });
      const clearLoading = () => {
        if(loadingCleared) return;
        loadingCleared = true;
        stickyButton.classList.remove('is-loading');
        stickyButton.removeAttribute('aria-busy');
        stickyButton.disabled = false;
        mainButtonObserver.disconnect();
        window.clearTimeout(loadingTimer);
        document.removeEventListener('cart:added', clearLoading);
        document.removeEventListener('cart:fetched', clearLoading);
        document.removeEventListener('cart:error', clearLoading);
      };

      mainButtonObserver.observe(mainButton, {attributes:true, attributeFilter:['disabled']});
      document.addEventListener('cart:added', clearLoading);
      document.addEventListener('cart:fetched', clearLoading);
      document.addEventListener('cart:error', clearLoading);
      loadingTimer = window.setTimeout(clearLoading, 8000);
      mainButton.click();
    });

    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule);
    new MutationObserver(schedule).observe(mainButton, {attributes:true, attributeFilter:['disabled']});
    if(cartRoot) new MutationObserver(schedule).observe(cartRoot, {attributes:true, childList:true, subtree:true});

    bar.dataset.stickyAtcReady = 'true';
    update();
  }

  function init(root = document){
    root.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(function(){
  function initFilterAccordion(accordion){
    if(accordion.dataset.filterAccordionReady === 'true') return;

    accordion.querySelectorAll(':scope > [data-item]').forEach(item => {
      const button = item.querySelector(':scope > h4 button[aria-controls]');
      const contentId = button?.getAttribute('aria-controls');
      const content = contentId ? document.getElementById(contentId) : null;
      if(!button || !content || !accordion.contains(content)) return;

      const setOpen = open => {
        const state = open ? 'open' : 'closed';
        item.dataset.state = state;
        button.dataset.state = state;
        content.dataset.state = state;
        button.setAttribute('aria-expanded', String(open));
        content.hidden = !open;
      };

      setOpen(button.getAttribute('aria-expanded') === 'true');
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        setOpen(button.getAttribute('aria-expanded') !== 'true');
      });
    });

    accordion.dataset.filterAccordionReady = 'true';
  }

  function init(root = document){
    root.querySelectorAll('[data-filter-accordion]').forEach(initFilterAccordion);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* Aarhus pop-up store stock line: follows the selected variant. The product
   form updates its hidden select, so the line is re-checked on every change
   and on the price node the variant switch rewrites. */
(function(){
  function initStoreStock(line){
    if(line.dataset.croStoreStockReady === 'true') return;

    const form = line.closest('form') || document;
    const select = form.querySelector('select[name="id"]');
    const ids = new Set((line.dataset.storeStockIds || '').split(',').filter(Boolean));
    if(!select || !ids.size) return;

    const update = () => {
      line.hidden = !ids.has(String(select.value));
    };

    form.addEventListener('change', () => setTimeout(update, 0));
    window.addEventListener('popstate', update);

    const price = document.querySelector('[data-price]');
    if(price) new MutationObserver(update).observe(price, {childList: true, characterData: true, subtree: true});

    update();
    line.dataset.croStoreStockReady = 'true';
  }

  function init(root = document){
    root.querySelectorAll('[data-store-stock]').forEach(initStoreStock);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
